module.exports = __webpack_public_path__ + "img/xiaomi12timage1.e710855b.png";